window.FOF = function() {
  var _isDisplayed = false;
  
  var getIsDisplayed = function() {
    return _isDisplayed;
  };
  
  var setIsDisplayed = function(isDisplayed) {
    _isDisplayed = isDisplayed;
  }

  // Update cart count on main layout
  var updateCartQuantityBadge = function(itemCount) {
    if (itemCount > 0) {
      if ($('#CartCount').length == 0) {
        $('.site-header__cart').append(`<div id="CartCount" class="site-header__cart-count">
<span>0</span>
<span class="icon__fallback-text medium-up--hide">item</span>
</div>
`);
      }

      $('#CartCount span:first-child').text(itemCount);
    } else {
      $('#CartCount').remove();
    }
  };

  var styleMotivatorItems = function(cart) {
    if (cart && cart.items && cart.items.length > 0) {
      var motivatorItems = [];

      $(cart.items).each(function(index, item) {
        if (item.product_type == 'MOTIVATOR_HIDDEN_PRODUCT') {
          motivatorItems.push(item);
        }
      });

      if (motivatorItems.length > 0) {
        $(motivatorItems).each(function(index, item) {
          var $a = $('#slidecarthq .items .item .title a[href="' + item.url + '"]');

          if (!$a.data('fof-styled')) {
            $a.prepend("FREE ");
            $a.css('color', '#f81507');
            $a.data('fof-styled', true);
          }
          
          //$a.first().closest('.item').find('.quantity-selector button, .quantity-selector input').attr('disabled', 'disabled');
        });
      }
    }
  };

  var boldThemeCartCallback = function() {
    window.SLIDECART_UPDATE(function(arg1) {
      //styleMotivatorItems(arg1);
    });
  };

  return {
    updateCartQuantityBadge: updateCartQuantityBadge,
    boldThemeCartCallback: boldThemeCartCallback,
    styleMotivatorItems: styleMotivatorItems,
    getIsDisplayed: getIsDisplayed,
    setIsDisplayed: setIsDisplayed
  };
}();